var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-search-filters__tag hiq-search-filter"},[_c('search-filter-btn',{attrs:{"title":_vm.tag.title}}),_c('search-dropdown',{attrs:{"options":_vm.tag.options,"filterTitle":_vm.tag.title,"filterName":_vm.tag.name,"isTag":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }